import styled from "@emotion/styled/macro";
import { colors } from "../../../../common/styles/theme.styles";

export const VaultMainTableWrapper = styled.div`
    display: flex;
    padding: 0px 16px 16px 16px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 16px;
    background: #FFF;
    transition: all 0.2s ease-in-out;

    ${({ isHoverActive, isDropzoneDisabled }) => {
        if (isDropzoneDisabled) {
            return `
                opacity: 0.6;
                pointer-events: none;
            `;
        }
        
        if (isHoverActive) {
            return `
                background: ${colors.lightGrey2};
                border: 2px dashed ${colors.darkGray1};
            `;
        }
        
        return `
            border: 2px solid transparent;
        `;
    }}
`;

export const VaultMainTableHeader = styled.div`
    display: flex;
    padding: ${({ isEmptyState }) => isEmptyState ? '16px 8px 0px 8px' : '16px 8px 32px 8px'};
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;
`;

export const VaultMainTableHeaderTitle = styled.div`
    color: ${colors.darkGray1};
    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    line-height: 130%;
`;